import PropTypes from 'prop-types';
import React from 'react';
import { contentfulModels } from '@glowforge/ui-common';
import { articlePropTypes } from 'app/selectors/support';
import Article from 'app/components/support/article';
import ArticleStepGroup from './article-step-group';
import ActionButtons from './action-buttons';

import './shared.less';

const { pageStringsPropType } = contentfulModels;

const Exhaust = ({
  pageStrings,
  pageMarkdownStrings,
  nextUrl,
  exhaustPowerArticle,
  personalFilterArticle,
  windowVentingArticle,
  connectPowerArticle,
}) => (
  <div className='Exhaust PageContainer'>
    <ArticleStepGroup article={exhaustPowerArticle} />
    <ArticleStepGroup article={personalFilterArticle} />
    <Article {...windowVentingArticle} unboxingUpdateEnabled />
    <Article {...connectPowerArticle} />
    <ActionButtons
      getHelpMarkdownSource={pageMarkdownStrings['instructions-get-help']}
      nextStepOnClick={() => {
        window.location = `${nextUrl}?mode=orange`;
      }}
      nextStepStr={pageStrings['exhaust-next-step']} />
  </div>
);

Exhaust.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  pageMarkdownStrings: pageStringsPropType.isRequired,
  nextUrl: PropTypes.string.isRequired,
  exhaustPowerArticle: PropTypes.shape(articlePropTypes),
  personalFilterArticle: PropTypes.shape(articlePropTypes),
  windowVentingArticle: PropTypes.shape(articlePropTypes),
  connectPowerArticle: PropTypes.shape(articlePropTypes),
};

Exhaust.defaultProps = {
  exhaustPowerArticle: {},
  personalFilterArticle: {},
  windowVentingArticle: {},
  connectPowerArticle: {},
};

export default Exhaust;



// WEBPACK FOOTER //
// ./app/components/setup/exhaust.jsx